<template>
  <ControlWrapper
    v-bind="controlWrapper"
    :styles="styles"
    :is-focused="isFocused"
    :applied-options="appliedOptions"
    :error="control.errors"
  >
    <div class="widget-base-radio-group">
      <label :class="[styles.control.label, '!mb-3 inline-block']">{{ computedLabel }}</label>
      <p class="widget-base-radio-group_description">{{ control.description }}</p>
      <fieldset class="mt-6">
        <legend class="sr-only">{{ computedLabel }}</legend>
        <div
          :class="[twMerge('widget-base-radio-group_wrapper', styles.control.input), componentStyles?.radioGroup]"
          :disabled="!control.enabled"
          :autofocus="appliedOptions.focus"
          :placeholder="appliedOptions.placeholder"
          :hint="control.description"
          :persistent-hint="persistentHint()"
          :required="control.required"
        >
          <div
            v-for="option in control.schema.oneOf"
            :key="option.const"
            class="widget-base-radio-group_input-wrapper"
            @click="setSelectedOption(option.const)"
          >
            <WInput
              :disabled="!control.enabled"
              :id="String(option.const)"
              :name="computedLabel.toLowerCase().replaceAll(' ', '-')"
              type="radio"
              :checked="option.const === selectedOption"
              class="widget-base-radio-group_input"
              :data-selected="option.const === selectedOption"
              @input="setSelectedOption(option.const)"
              @keydown.enter="setSelectedOption(option.const)"
            />
            <label :for="option.const" class="widget-base-radio-group_label">{{ option.title }}</label>
          </div>
        </div>
      </fieldset>
      <p class="body1-bold text-negative-500">{{ control.errors }}</p>
    </div>
  </ControlWrapper>
</template>

<script lang="ts">
  import { ControlElement } from '@jsonforms/core';
  import { defineComponent, ref } from 'vue';
  import { twMerge } from 'tailwind-merge';
  import { rendererProps, useJsonFormsEnumControl, RendererProps } from '@jsonforms/vue';
  import { default as ControlWrapper } from './ControlWrapper.vue';
  import { useWidgetControl } from '../util';
  import WInput from '../../base/Input.vue';
  import { config, checkTheme, getComponentStyle } from 'src/utils/config';

  export default defineComponent({
    name: 'RadioGroupControlRenderer',
    components: {
      ControlWrapper,
      WInput,
    },
    props: {
      ...rendererProps<ControlElement>(),
    },
    setup(props: RendererProps<ControlElement>) {
      const control = useWidgetControl(useJsonFormsEnumControl(props));
      const selectedOption = ref(control.control.value.data as string);
      const componentStyles = getComponentStyle();
      function setSelectedOption(val: string) {
        selectedOption.value = val;
        control.onChange(val);
      }
      return {
        selectedOption,
        config,
        setSelectedOption,
        twMerge,
        checkTheme,
        componentStyles,
        ...control,
      };
    },
  });
</script>
